import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { id: "globalevent" }
const _hoisted_2 = { class: "event-title" }
const _hoisted_3 = { class: "event-list" }
const _hoisted_4 = { class: "event-card event-front" }
const _hoisted_5 = { class: "event-info" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "sub-title" }
const _hoisted_8 = { class: "text" }
const _hoisted_9 = { class: "buttons" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "event-card event-back" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "event-name" }, "- 全局事件 -", -1)
const _hoisted_14 = { class: "deck-info" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h1", { class: "deck-title" }, "五谷丰登", -1)
const _hoisted_16 = { class: "players" }
const _hoisted_17 = { class: "deck-list-box" }
const _hoisted_18 = { class: "card card-front" }
const _hoisted_19 = { class: "card-info" }
const _hoisted_20 = { class: "card-id" }
const _hoisted_21 = { class: "card-name" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "card card-back" }, null, -1)

import {
  globalEventList,
  deckDialogVisible,
  eventFlipList,
  eventTitle,
  playersText,
  selfDeckList,
  cardFlip,
  acceptEvent,
  finishEvent,
  initGlobalEvent
} from "@/assets/ts/globalevent";


export default /*#__PURE__*/_defineComponent({
  __name: 'GlobalEventView',
  setup(__props) {


initGlobalEvent();

return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(eventTitle)), 1),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(globalEventList), (globalEvent, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "event-box",
          key: index
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["event-item", {'flip': _unref(eventFlipList)[index]}])
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_6, _toDisplayString(globalEvent.eventName), 1),
                  _createElementVNode("p", _hoisted_7, _toDisplayString(globalEvent.name), 1)
                ]),
                _createElementVNode("p", _hoisted_8, _toDisplayString(globalEvent.description), 1),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("button", {
                    class: "button confirm",
                    style: _normalizeStyle({'display': (globalEvent.stage === 'none' || globalEvent.stage === 'timeout')
                                            ? 'block' : 'none'}),
                    onClick: ($event: any) => (_unref(acceptEvent)(globalEvent, index))
                  }, "接受 ", 12, _hoisted_10),
                  _createElementVNode("button", {
                    class: "button finish",
                    style: _normalizeStyle({'display': globalEvent.stage === 'active' ? 'block' : 'none'}),
                    onClick: ($event: any) => (_unref(finishEvent)(globalEvent, index))
                  }, "完成 ", 12, _hoisted_11)
                ])
              ])
            ]),
            _hoisted_12
          ], 2),
          _hoisted_13
        ]))
      }), 128))
    ]),
    _createVNode(_component_el_dialog, {
      class: "dialog deck-dialog",
      modelValue: _unref(deckDialogVisible),
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(deckDialogVisible) ? (deckDialogVisible).value = $event : null)),
      "close-on-click-modal": false,
      width: "79.25rem",
      "align-center": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("p", _hoisted_16, _toDisplayString(_unref(playersText)), 1)
        ]),
        _createElementVNode("div", _hoisted_17, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selfDeckList), (card, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["card-item", {'flip': _unref(cardFlip)[index]}]),
              key: index
            }, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("p", _hoisted_20, _toDisplayString(card.cardName), 1),
                  _createElementVNode("p", _hoisted_21, _toDisplayString(card.name), 1)
                ])
              ]),
              _hoisted_22
            ], 2))
          }), 128))
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "button deck-confirm",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (deckDialogVisible.value = false))
        }, "确认")
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})